import { Anchor, Button, Stack, Text, TextInput, Title } from "@mantine/core";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { Link, useSearchParams } from "react-router";
import { getCloudMetadata, getCurrentUser } from "./getCurrentUser";
import { persistReturnHash, redirectToSignIn } from "./authGuards";

export function Login() {
  const { t } = useTranslation();
  const [params] = useSearchParams();
  const user = getCurrentUser();
  const metadata = getCloudMetadata();
  const returnTo = params.get("return") || "/distributorportal";

  React.useEffect(() => {
    if (user) {
      // Already signed in — send them where they wanted to go
      window.location.hash = "#" + (returnTo.startsWith("/") ? returnTo : "/" + returnTo);
    }
  }, [user, returnTo]);

  const onGoogleSignIn = () => {
    persistReturnHash(returnTo.startsWith("/") ? returnTo : "/" + returnTo);
    redirectToSignIn();
  };

  if (user) {
    return (
      <Stack gap="md" maw={480}>
        <Title order={3}>{t("signin.alreadySignedIn")}</Title>
        <Text>{t("signin.signedInAs", { email: user.AccountEmail || user.Email })}</Text>
        <Button component={Link} to={returnTo.startsWith("/") ? returnTo : "/" + returnTo}>
          {t("signin.continue")}
        </Button>
        <Anchor href="/logout">{t("nav.logout")}</Anchor>
      </Stack>
    );
  }

  // Cookie present but no cloud user is auto-registered by HomeController.
  // Show Google sign-in for fully anonymous visitors.
  return (
    <Stack gap="md" maw={480}>
      <Title order={3}>{t("signin.title")}</Title>
      <Text>{t("signin.intro")}</Text>
      <Button onClick={onGoogleSignIn}>{t("signin.withGoogle")}</Button>
      <Text size="sm" c="dimmed">
        {t("signin.agreePrefix")}{" "}
        <Anchor component={Link} to="/privacy">
          {t("signin.privacyLink")}
        </Anchor>
      </Text>
      {metadata.SignInUrl ? null : (
        <TextInput label={t("signin.debugSignInUrl")} value="(missing)" readOnly />
      )}
    </Stack>
  );
}
